import Vue from "vue";
import { mapGetters } from "vuex";
import { adjustSummaryBlocks } from "../../../components/cartUtil";

const debounce = require("lodash/debounce");

const OrderSummaryTitle = Vue.component("order-summary-title", {
    template: `
    <div class="col-12 ct-cart--summary-title-container">
        <p class="ct-cart--summary-title pwc-font--primary-bold">
            {{resources.summaryTitle}}
        </p>
    </div>`,
    props: ["resources"]
});

/**
 * Order summary products Component
 */
const OrderSummaryProducts = Vue.component("order-summary-products", {
    template: `
    <div class="js-products-number-area ct-cart--summary-info-block">
        <span class="ct-cart--summary-label pwc-font--primary-regular total-discount-label">
            {{ resources.summaryProductsLabel }}
            <span class="js-number-of-items" v-if="(resources.totalNumberOfProducts || item.productsCount) && (resources.totalNumberOfProducts > 0 || item.productsCount > 0)">
                ({{ ismultishipping ? item.productsCount : resources.totalNumberOfProducts }})
            </span>
            <span class="js-number-of-items" v-else>
                ({{ resources.summaryNoProductsLabel }})
            </span>
        </span>
        <span class="ct-cart--summary-value pwc-font--primary-regular js-total-value">
            {{ ismultishipping ? item.productsTotalPriceInShipment.formatted : resources.totals.totalPriceProductsOnly }}
        </span>
    </div>`,
    props: ["resources", "ismultishipping", "item"]
});

/**
 * Order summary plastic bag Component
 */
const OrderSummaryPlasticBag = Vue.component("order-summary-plastic-bag", {
    template: 
    /* html */`
    <div :class="[((!ismultishipping && resources.numberOfPlasticBags) || item.plasticBagsInShipment) && ((!ismultishipping && resources.numberOfPlasticBags > 0) || item.plasticBagsInShipment > 0) ? '' : 'd-none', 'js-plastic-bags-area ct-cart--summary-info-block']">
        <span class="ct-cart--summary-label pwc-font--primary-regular total-discount-label d-flex align-items-center">
            {{ resources.summaryPlasticBagLabel }}
            <span class="js-number-of-items ct-cart--plastic-bags-number" v-if="((!ismultishipping && resources.numberOfPlasticBags) || item.plasticBagsInShipment) && ((!ismultishipping && resources.numberOfPlasticBags > 0) > 0 || item.plasticBagsInShipment > 0)">
                ({{ ismultishipping ? item.plasticBagsInShipment : resources.numberOfPlasticBags }})
            </span>
            <span v-html="icon"
                class="button--transparent-secondary ct-cart--summary-plastic-bag-info pwc-tooltip-trigger"
                data-toggle="tooltip"
                data-placement="left"
                :title="resources.summaryPlasticBagTooltip">
            </span>
        </span>
        <span class="ct-cart--summary-value pwc-font--primary-regular total-discount-value">
            {{ ismultishipping ? (getPlasticBagsPrice() || '') : resources.plasticBagsTotalValue }}
        </span>
    </div>`,
    methods: {
        getPlasticBagsPrice() {
            if (!this.ismultishipping) {
                return false;
            }

            if (this.item.plasticBagsInShipment > 0) {
                const plasticBagItem = this.item.productLineItems.items.find(elem => elem.id == this.resources.plasticBagSKU);

                if (plasticBagItem) {
                    return plasticBagItem.priceTotal.price;
                }
            }
            return false;
        },
        initializeTooltip() {
            this.$nextTick(() => {
                const tooltipElement = this.$el.querySelector(".ct-cart--summary-plastic-bag-info");
                if (tooltipElement) {
                    $(tooltipElement).tooltip({ placement: "top" });
                }
            });
        }
    },
    mounted() {
        this.initializeTooltip();
    },
    props: ["resources", "ismultishipping", "item", "icon"]
});

/**
 * Order summary shipping cost Component
 */
const OrderSummaryShippingCost = Vue.component("order-summary-shipping-cost", {
    template: `
    <div :class="['js-shipping-cost-area ct-cart--summary-info-block', { 'd-none': !displayShippingCost() || resources.isEntregaZero }]">
        <span class="ct-cart--summary-label pwc-font--primary-regular shipping-area-label">
            {{ resources.summaryShippingCostLabel }}
        </span>
        <span v-if="!this.getCheckoutPageBoolean()" class="ct-cart--summary-value pwc-font--primary-regular shipping-total-cost" :data-shipment-id="item.externalShipmentID">
            {{ item.slotShippingCost}}
        </span>
        <span v-else class="ct-cart--summary-value pwc-font--primary-regular shipping-total-cost" :data-shipment-id="item.externalShipmentID">
            {{ item.selectedShippingMethod.shippingCost }}
        </span>
    </div>`
    ,
    computed: {
        ...mapGetters([
            "getCheckoutPageBoolean",
            "getShipmentData"
        ])
    },
    methods: {
        displayShippingCost() {
            const checkoutPage = this.getCheckoutPageBoolean();
            const externalShipmentId = this.item.externalShipmentID;
            const currentShipmentData = this.getShipmentData(externalShipmentId);

            if (checkoutPage) {
                //shippingCost value is formed from currentShipmentData(selected slot data) in code before, so if we don't have this object - slot was not selected
                if (!currentShipmentData) return false;

                if (!currentShipmentData.discountPrice) return false;
            }

            const shippingCost = checkoutPage ? this.item.selectedShippingMethod.shippingCost : this.item.slotShippingCost;

            if (currentShipmentData) {
                const deliverySlots = currentShipmentData.shipmentDeliverySlots;
                if (deliverySlots && deliverySlots.groupedDeliverySlots && !deliverySlots.isNonScheduled) {
                    if (!deliverySlots.groupedDeliverySlots[0] || !deliverySlots.groupedDeliverySlots[0].slotDetails || !deliverySlots.groupedDeliverySlots[0].slotDetails[0]) {
                        return;
                    }
                }

                if (!shippingCost) return false;
            }

            const shippingCostValue = shippingCost.split(" ")[1]?.replace(",", ".");

            return parseFloat(shippingCostValue, 10) != 0;
        }
    },
    props: ["resources", "item"]
});


/**
 * Order summary coupons Component
 */
const OrderSummaryCoupons = Vue.component("order-summary-coupons", {
    template: `
    <div :class="['js-coupon-discount-area ct-cart--summary-info-block', resources.totals && resources.totals.couponLevelDiscountTotal ? '' : 'd-none']">
        <span class="ct-cart--summary-label pwc-font--primary-regular total-discount-label">
            {{ resources.summaryCouponsLabel }}
        </span>
        <span class="ct-cart--summary-value pwc-font--primary-regular total-discount-value" v-if="resources.totals && resources.totals.couponLevelDiscountTotal">
           - {{ resources.totals.couponLevelDiscountTotal }}
        </span>
    </div>`
    ,
    props: ["resources"]
});

/**
 * Order summary Loyalty card Component
 */
const OrderSummaryLoyaltyCard = Vue.component("order-summary-loyalty-card", {
    template: `
    <div :class="['ct-cart--summary-info-block', this.isReviewPageAndLoyaltyApplied || isNotReviewPageAndLoyaltyApplied ? '' : 'd-none']" >
        <span class="ct-cart--summary-label ct-cart--summary-loyalty-label pwc-font--primary-regular">
            {{ resources.summaryLoyaltyLabel }}
        </span>
        <span v-if="this.isReviewPageAndLoyaltyApplied" class="ct-cart--summary-value pwc-font--primary-regular">
            - {{ resources.nonFinancialUsedAmount.LoyaltyCard.displayValue }}
        </span>
        <span v-else-if="isNotReviewPageAndLoyaltyApplied" class="ct-cart--summary-value pwc-font--primary-regular">
            - {{ resources.loyaltyBalance }}
        </span>
    </div>`
    ,
    data() {
        return {
            isReviewPageAndLoyaltyApplied: false
        };
    },
    computed: {
        isNotReviewPageAndLoyaltyApplied() {
            return this.resources.loyaltyBalance && this.resources.loyaltyBalanceValue != 0 && !this.getOrderReviewPageBoolean();
        },
        ...mapGetters([
            "getOrderReviewPageBoolean"
        ])
    },
    mounted() {
        this.isReviewPageAndLoyaltyApplied = this.resources.nonFinancialUsedAmount.LoyaltyCard && this.getOrderReviewPageBoolean();
    },
    watch: {
        "resources.loyaltyBalance": debounce(adjustSummaryBlocks, 1)
    },
    props: ["resources"]
});

/**
 * Order summary Cartao Da Component
 */
const OrderSummaryCartaoDa = Vue.component("order-summary-cartao-da", {
    template: `
    <div :class="['ct-cart--summary-info-block', isNotReviewPageAndGiftApplied || this.isReviewPageAndGiftApplied ? '' : 'd-none']">
        <span class="ct-cart--summary-label pwc-font--primary-regular">
            {{ resources.summaryCartaoDaLabel }}
        </span>
        <span v-if="this.isReviewPageAndGiftApplied" class="ct-cart--summary-value pwc-font--primary-regular">
            - {{ resources.nonFinancialUsedAmount.ContinentePayDa.displayValue}}
        </span>
        <span v-else-if="isNotReviewPageAndGiftApplied" class="ct-cart--summary-value pwc-font--primary-regular">
            - {{ resources.cartaodaBalance }}
        </span>
    </div>`
    ,
    data() {
        return {
            isReviewPageAndGiftApplied: false
        };
    },
    computed: {
        isNotReviewPageAndGiftApplied: function () {
            return this.resources.cartaodaBalance && this.resources.cartaodaBalanceValue != 0 && !this.getOrderReviewPageBoolean();
        },
        ...mapGetters([
            "getOrderReviewPageBoolean"
        ])
    },
    mounted() {
        this.isReviewPageAndGiftApplied = this.resources.nonFinancialUsedAmount.ContinentePayDa && this.getOrderReviewPageBoolean();
    },
    watch: {
        "resources.cartaodaBalance": debounce(adjustSummaryBlocks, 1)
    },
    props: ["resources"]
});

/**
 * Order summary Discount Component
 */
const OrderSummaryDiscount = Vue.component("order-summary-discount", {
    template: `
    <div :class="['js-summary-order-level-discount  ct-cart--summary-info-block', resources.totals.orderLevelDiscountTotal && resources.totals.orderLevelDiscountTotal.value != 0 ? '' : 'd-none']">
        <span class="ct-cart--summary-label pwc-font--primary-regular total-discount-label">
            {{ resources.summaryDiscountLabel }}
        </span>
        <span class="ct-cart--summary-value pwc-font--primary-regular js-order-level-discount-value" v-if="resources.totals.orderLevelDiscountTotal && resources.totals.orderLevelDiscountTotal.value != 0">
            {{ resources.totals.orderLevelDiscountTotal.formatted }}
        </span>
    </div>`
    ,
    props: ["resources"]
});

/**
 * Order summary shipping information
 */
const OrderSummaryShippingInfo = Vue.component("order-summary-shipping-info", {
    template: `
    <div :class="multishipping ? 'col-sm-6 col-md-auto w-100 ct-cart--split-shipping-block p-md-0' : 'col-12'">
        <div class="ct-cart--summary-title-container d-flex" v-if="multishipping">
            <span class="ct-cart--summary-label pwc-font--primary-bold">
                {{ resources.summarySplitShippingLabel }} {{ index + 1 }}
            </span>
            <span class="ct-cart--summary-value"></span>
        </div>
        <order-summary-products
            :resources="resources"
            :ismultishipping="multishipping"
            :item="item" />
        <order-summary-plastic-bag
            :resources="resources"
            :icon="questionmarkicon"
            :ismultishipping="multishipping"
            :item="item" />
        <order-summary-shipping-cost
            :resources="resources"
            :item="item" />
        <div v-if="resources.authenticatedCustomer && resources.isEntregaZero">
            <div :class="['ct-cart--summary-mobile-entrega-zero', resources.isEntregaZero ? '' : 'd-none d-md-block']">
                <order-summary-entrega-zero
                    :resources="resources"
                    :icon="iconEntregaZero" />
            </div>
        </div>
    </div>`,
    props: ["resources", "multishipping", "item", "index", "questionmarkicon", "iconEntregaZero"],
    computed: {
        ...mapGetters(["getOrderReviewPageBoolean"])
    },
    components: {
        OrderSummaryTitle,
        OrderSummaryProducts,
        OrderSummaryPlasticBag,
        OrderSummaryShippingCost
    }
});

/**
 * Order summary promotions information
 */
const OrderSummaryPromotionsInfo = Vue.component("order-summary-promotions-info", {
    template: /* html */`
    <div :class="['ct-cart--summary-discounts', multishipping ? 'col-sm-6 col-md-auto pr-md-0' : 'col-12',
        resources.loyaltyBalance ||
        resources.cartaodaBalance ||
        resources.totals.couponLevelDiscountTotal ||
        resources.nonFinancialUsedAmount.ContinentePayDa && this.getOrderReviewPageBoolean() ||
        resources.nonFinancialUsedAmount.LoyaltyCard && this.getOrderReviewPageBoolean() ||
        resources.totals.orderLevelDiscountTotal && resources.totals.orderLevelDiscountTotal.value != 0 ? '' : 'd-none']"
    >
        <order-summary-discount :resources="resources" />
        <order-summary-coupons :resources="resources" />
        <order-summary-loyalty-card :resources="resources" />
        <order-summary-cartao-da :resources="resources" />
    </div>`,
    props: ["resources", "multishipping"],
    mounted() {
        this.$nextTick(() => {
            adjustSummaryBlocks();
        });
    },
    computed: {
        ...mapGetters(["getOrderReviewPageBoolean"])
    },
    components: {
        OrderSummaryCoupons,
        OrderSummaryDiscount,
        OrderSummaryLoyaltyCard,
        OrderSummaryCartaoDa
    }
});

/**
 * Order summary entrega zero Component
 */
const OrderSummaryEntregaZero = Vue.component("order-summary-entrega-zero", {
    template: `
    <div
        v-if="resources.isEntregaZero || (!this.getOrderReviewPageBoolean() && !this.getCheckoutPageBoolean() && !this.getPaymentPageBoolean())"
        :class="['ct-cart--summary-info-block', resources.totalNumberOfProducts && resources.totalNumberOfProducts > 0 && resources.isEntregaZeroCustomer && !resources.onlyEntregaService ? '' : 'd-none']"
    >
        <div :class="['ez-threshold-message ct-cart--summary-label pwc-font--primary-regular', resources.isEntregaZero ? '' : 'ct-cart--entrega-zero-inferior']"
        :data-over-threshold-message="resources.summaryEZOverThresholdMsg"
        :data-below-threshold-message-short="resources.summaryEZBelowThresholdMsgShort"
        :data-below-threshold-message-long="resources.summaryEZBelowThresholdMsgLong"
        :data-threshold="resources.storeThreshold"
        :data-entrega-zero-delay="resources.entregaZeroDelayTime"
        :data-entrega-zero-customer="resources.isEntregaZeroCustomer">
            <div v-if="resources.isEntregaZero">
                {{ resources.summaryEZOverThresholdMsg }}
            </div>
            <div v-else>
                <span class="below-threshold-message d-md-none">
                    {{ resources.summaryEZBelowThresholdMsgLong }}
                </span>
                <span class="below-threshold-message d-none d-md-block">
                    {{ resources.summaryEZBelowThresholdMsgShort }}
                </span>
            </div>
        </div>
        <div :class="['ct-cart--summary-value ct-cart--entrega-zero-icon', resources.isEntregaZero ? 'ct-cart--entrega-zero-icon-active' : '']"   v-html="icon">
        </div>
    </div>`
    ,
    computed: {
        ...mapGetters([
            "getOrderReviewPageBoolean",
            "getCheckoutPageBoolean",
            "getPaymentPageBoolean"
        ])
    },
    props: ["resources", "icon"]
});

export {
    OrderSummaryTitle,
    OrderSummaryProducts,
    OrderSummaryPlasticBag,
    OrderSummaryShippingCost,
    OrderSummaryShippingInfo,
    OrderSummaryPromotionsInfo,
    OrderSummaryEntregaZero
};
